import { DialogBox } from "lib/@components/dialogBox"
import { Frag } from "lib/@components/slot/frag"
import { RejectionComment } from "./rejection-comment"

export function RejectionDialog({ content, approvedCount = 0, rejectedCount = 0 }) {
    return (
        <DialogBox Actions={Frag}>
            <RejectionComment content={content} approvedCount={approvedCount} rejectedCount={rejectedCount} />
        </DialogBox>
    )
}
